import type { CommandData } from '../types'

export function hidePreviewMessage() {
  const message: CommandData = {
    isFromBeeetle: true,
    command: 'hidePreviewMessage',
  }
  window.postMessage(message)
} 